<template>
<v-container grid-list-xl fluid>
    <pay-authority-list :showComplainOnly='1'></pay-authority-list>
</v-container>
</template>

<script>
import PayAuthorityList from "@/views/PayAuthority/list";
export default {
    components: {
        "pay-authority-list": PayAuthorityList
    }    
};
</script>
